// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4b25b842","241":"65b91ad0","421":"4198c2a8","666":"d15a24df","667":"b55adac2","802":"4198c2a8","941":"0fa1d247"}[chunkId] + ".chunk.js";
};